import { GlobovmsLogo } from "../brand/GlobovmsLogo";

const links = [
  ["Product", "#overview"],
  ["How it works", "#lifecycle"],
  ["Industries", "#industries"],
  ["Integrations", "#integrations"],
  ["Request a demo", "#demo"],
];

export function Footer() {
  return (
    <footer className="bg-[#0B1C33] px-5 py-10 text-sm text-slate-300">
      <div className="mx-auto max-w-7xl">
        <div className="flex flex-col gap-8 border-b border-white/10 pb-8 lg:flex-row lg:items-center lg:justify-between">
          <div>
            <GlobovmsLogo light />
            <p className="mt-3 max-w-sm text-slate-300">Visitor management for secure facilities across Africa.</p>
          </div>
          <nav className="flex flex-wrap gap-x-6 gap-y-3" aria-label="Footer">
            {links.map(([label, to]) => (
              <a key={to} href={to} className="font-semibold text-white transition-colors duration-200 hover:text-brand-blue">{label}</a>
            ))}
          </nav>
        </div>
        <div className="flex flex-col gap-2 pt-6 text-slate-400 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 Globotech. globoVMS by Globotech.</p>
          <p>A demo request stores the details you submit. It does not ask for identity document numbers.</p>
        </div>
      </div>
    </footer>
  );
}
